import { format, isValid } from 'date-fns'
import { SnapshotDetails } from '../SnapshotModal/SnapshotModal.types'
import { MenuItem } from 'Common/Supplyvue-ui/DropDown.types'

export const SNAPSHOT_LENGTH_MENU_ITEMS: MenuItem[] = [
  {
    label: '36 months ( 156 weeks / 1095 days )',
    value: 156,
  },
  {
    label: '24 months ( 104 weeks / 730 days )',
    value: 104,
  },
  {
    label: '18 months ( 78 weeks / 548 days )',
    value: 78,
  },
  {
    label: '12 months ( 52 weeks / 365 days )',
    value: 52,
  },
  {
    label: '9 months ( 39 weeks / 274 days )',
    value: 39,
  },
  {
    label: '6 months ( 26 weeks / 183 days )',
    value: 26,
  },
]

export const disableWeekdays = (date: Date) => {
  return date.getDay() !== 0
}

export const isValidDate = (date: Date | null) => {
  const MINYEAR = 1900
  const today = new Date()
  const isPastYear = date && date.getFullYear() < today.getFullYear()
  const isPastMonthOfSameYear =
    date &&
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() < today.getMonth()
  const isDateValidForSameMonthAndYear =
    date &&
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() <= today.getDate()

  return (
    date &&
    isValid(date) &&
    date.getFullYear() >= MINYEAR &&
    (isPastYear || isPastMonthOfSameYear || isDateValidForSameMonthAndYear)
  )
}

export const getLastSunday = () => {
  const today = new Date()
  today.setDate(today.getDate() - today.getDay())
  return today
}

export const getSnapshotDetailsInString = (
  snapshot:
    | SnapshotDetails
    | Omit<SnapshotDetails, 'snapshotId' | 'snapshotUserId'>
) => {
  return `${snapshot.snapshotName} ( period = ${
    snapshot.snapshotLength
  } weeks, end date = ${format(
    new Date(snapshot.snapshotEndDate),
    'dd/MM/yyyy'
  )} ) `
}

export const getSelectSnapshotDropdownMenuItems = (
  data: SnapshotDetails[]
): MenuItem[] => {
  return data?.map((snapshot: SnapshotDetails) => {
    const key = getSnapshotDetailsInString(snapshot)
    return {
      label: key,
      value: snapshot.snapshotId,
    }
  })
}
